<script setup lang="ts">
  import { ref, onMounted } from "vue";
  import { useRouter } from "vue-router";
  import { IconLogo } from "@ui-kit";
  import { useProfileOptions } from "@src/hooks";

  const { push } = useRouter();
  const { permissionsIsEmpty } = useProfileOptions();

  const visibleLogo = ref(false);

  const handleGoToHome = () => {
    const url = permissionsIsEmpty() ? "/403" : "/login";

    setTimeout(() => {
      push(url);
    }, 300);
  };

  onMounted(() => {
    setTimeout(() => {
      visibleLogo.value = true;
    }, 1000);
  });
</script>

<template>
  <div class="home-page" data-testid="home-page">
    <div class="home-page__content">
      <IconLogo :class="['home-page__logo', { 'home-page__logo--show': visibleLogo }]" @transitionend="handleGoToHome" />
    </div>
  </div>
</template>

<style scoped>
  .home-page {
    display: flex;
    flex-direction: column;
    flex: 1;
    background-color: var(--sf-base-background-white);
  }

  .home-page__content {
    display: flex;
    flex-direction: column;
    gap: 24px;
    flex: 1;
    justify-content: center;
    align-items: center;
  }

  .home-page__logo {
    width: 180px;
    height: 40px;
    fill: var(--sf-base-icon-primary);
    opacity: 0;
    transition: opacity 0.6s ease-out;
  }

  .home-page__logo--show {
    opacity: 1;
  }
</style>
